import { User } from '../../user/user.model';

export class Person extends User {

    private _user: User | undefined;

    public get user(): User | undefined {
        return this._user;
    }

    public set user(value: any) {
        this._setValue('_user', value, 'User');
    }

}
